export const ChevronRightIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M8 4L16 11.5L8 19' stroke='currentColor' strokeWidth='2' />
    </svg>
);
